import DefaultValue from "./default-value";

export default class ReturnedByDefaultValue extends DefaultValue {
    constructor(play, fragment, summaryContext) {
        super(play, fragment, summaryContext);
    }

    resolve() {
        const { interceptedBy } = this.fragment || {};
        const { recoveredBy } =
            this.play.getPreviousFragment(this.fragment) || {};
        const defaultValue = interceptedBy || recoveredBy;
        return defaultValue ? [defaultValue] : super.resolve();
    }
}
